import React from "react";
import InputField from "../../forms/input-field";

const StorePaymentHistoryTab = ({ disabled = false }) => {
  return (
    <div className="w-full 2xl:w-[35%] lg:w-[60%] px-5 xl:px-10 mt-5">
      <InputField
        isDisabled={true}
        type="text"
        name="payment_method"
        placeholder="—"
        label="Payment Method"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="transaction_id"
        placeholder="—"
        label="Transaction ID"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="datetime-local"
        name="payment_recevie_time"
        placeholder="—"
        label="Payment Receive Time"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payer_name_as_per_bank"
        placeholder="—"
        label="Payer Name (Bank)"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payee_bank_name"
        placeholder="—"
        label="Payee Bank Name"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payee_bank_account_no"
        placeholder="—"
        label="Payee Account No."
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="isfc_code"
        placeholder="—"
        label="IFSC Code"
        labelWidth="13rem"
      />
    </div>
  );
};

export default StorePaymentHistoryTab;